import { tenantConfig } from 'global/tenant-config';

export function isBrikkAdded(brikkId) {
  return tenantConfig.brikks.includes(brikkId);
}
